module.exports = __webpack_public_path__ + "static/media/spotify-podcasts-button.5ac4c36b.jpg";